import WaybillsRequests from '../../server/waybills';
import { addLoading, removeLoading } from './loading';

export const getWaybillsByDate = (StartDate, EndDate) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await WaybillsRequests.getWaybillsByDate(StartDate, EndDate);
  } finally {
    dispatch(removeLoading());
  }
};

export const syncWaybillErp = (waybillId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await WaybillsRequests.syncWaybillErp(waybillId);
  } finally {
    dispatch(removeLoading());
  }
};

export const generateManualWaybill = (outboundOrderIds, branchCode, carrierCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await WaybillsRequests.generateManualWaybill(outboundOrderIds, branchCode, carrierCode);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteManualWaybill = (waybillId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await WaybillsRequests.deleteManualWaybill(waybillId);
  } finally {
    dispatch(removeLoading());
  }
};
